import anime from 'animejs'

import { get } from '@bigyouth/base'

import withResponsive from '../hoc/withResponsive'

const AUTOPLAY_DELAY = 5000

export default withResponsive({
  name: 'slider',

  ui: {
    'slides[]': '[js-slider-slide]',
    'dots[]': '[js-slider-dot]',
    'dotButtons[]': '[js-slider-dot-button]',
  },

  events: [
    {
      target: 'dotButtons',
      on: 'click',
      handle ({ target }) {
        if (this.isAutoplay) {
          clearTimeout(this.timeoutOff)
          this.startNextAutoplayStep()
        }

        this.goToSlide(target, parseInt(target.getAttribute('data-dot-id')))
      },
    },
  ],

  componentDidMount () {
    this.lastSelectedIndex = 0
    this.selectedIndex = 0
    this.isAnimating = false
    // this.isAutoplay = this.ui.dots.length > 1
    this.isAutoplay = false

    if (this.isAutoplay) {
      this.startNextAutoplayStep()
    }
  },

  goToSlide (button, targetIndex) {
    if (!this.isAnimating) {
      this.ui.dots[this.selectedIndex].classList.remove('is-selected')
      this.ui.slides[this.lastSelectedIndex].classList.remove('was-selected')
      this.ui.slides[this.selectedIndex].classList.remove('is-selected')

      // Updates indexes
      this.lastSelectedIndex = this.selectedIndex
      this.selectedIndex = targetIndex

      this.ui.dots[this.selectedIndex].classList.add('is-selected')

      // Update buttons
      const lastButton = get('button', this.ui.dots[this.lastSelectedIndex])
      lastButton.removeAttribute('disabled')
      button.setAttribute('disabled', true)

      this.animateSlide(this.ui.slides[this.selectedIndex])
    }
  },

  startNextAutoplayStep () {
    this.timeoutOff = setTimeout(() => {
      if (this.selectedIndex >= this.ui.dots.length - 1) {
        this.goToSlide(this.ui.dotButtons[0], 0)
      } else {
        this.goToSlide(this.ui.dotButtons[this.selectedIndex + 1], this.selectedIndex + 1)
      }

      this.startNextAutoplayStep()
    }, AUTOPLAY_DELAY)
  },

  animateSlide (slide) {
    const leftMask = get('[js-slider-slide-mask][data-side="left"]', slide)
    const leftSide = get('[js-slider-slide-content]', leftMask)
    const rightMask = get('[js-slider-slide-mask][data-side="right"]', slide)
    const rightSide = get('[js-slider-slide-content]', rightMask)

    leftMask.style.transform = 'translateY(-100%)'
    leftSide.style.transform = 'translateY(100%)'
    rightMask.style.transform = 'translateY(100%)'
    rightSide.style.transform = 'translateY(-100%)'

    // is-selected set the selected slide to be on top of the others and was-selected set the last one tu be just below
    this.ui.slides[this.lastSelectedIndex].classList.add('was-selected')
    this.ui.slides[this.selectedIndex].classList.add('is-selected')

    this.isAnimating = true

    anime({
      targets: [ leftMask, leftSide, rightMask, rightSide ],
      translateY: 0,
      duration: 1100,
      easing: [0.6, 0.1, 0.1, 1],
      complete: () => { this.isAnimating = false },
    })
  },
})
